import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CommonUtilityLib, NavigationEntry, NavigationItem, UserAccessService } from '@thehubz/client/core';

@Component({
  selector: 'thehubz-menu-items',
  templateUrl: './menu-items.component.html',
  styleUrls: ['./menu-items.component.scss'],
})
export class MenuItemsComponent implements OnInit {
  @Input() menuItemList!: NavigationEntry[];

  @Output() hideMainMenu = new EventEmitter<string>();

  indexNumber = 0;
  subMenuItemList: NavigationItem[] = [];
  currentURL = '';

  constructor(private readonly router: Router, private readonly commonUtilityLib: CommonUtilityLib, private readonly userAccessService: UserAccessService) {
    this.subMenuItemList = [];
  }

  ngOnInit(): void {
    this.checkRoute();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.checkRoute();
      }

      this.hideMainMenu.emit();
    });
  }

  checkRoute() {
    this.currentURL = this.router.url;
    let menuFlag = false;

    for (let i = 0; i < this.menuItemList?.length; i++) {
      const menuItem = this.menuItemList[i];
      for (let nav = 0; nav < menuItem.items?.length; nav++) {
        const matchURL = '/' + menuItem.items[nav].routerLink;
        if (this.currentURL.indexOf(matchURL) != -1) {
          menuFlag = true;
          this.indexNumber = i;
          this.subMenuItemList = menuItem.items.filter((item: NavigationItem) => {
            return item.accessRole ? this.userAccessService.hasRole(item.accessRole) : true;
          });
        }
        if (matchURL === '/dashboard' && this.currentURL === '/welcome') {
          this.indexNumber = i;
        }
      }
    }
    if (!menuFlag) {
      if (this.menuItemList && this.menuItemList[0]) {
        this.subMenuItemList = this.menuItemList[0]['items'];
      }
    }
  }

  changeSelection(_evt: MouseEvent, index: number) {
    this.indexNumber = index;
    this.subMenuItemList = this.menuItemList[index]['items'].filter((item: NavigationItem) => {
      return item.accessRole ? this.userAccessService.hasRole(item.accessRole) : true;
    });
    this.commonUtilityLib.routingObjectSetter(this.menuItemList[index]['items'][0]);
    if (this.menuItemList[index]['items'][0]['target'] === 'blank') {
      this.openNewTab(this.menuItemList[index]['items'][0]['routerLink']);
    } else {
      this.router.navigateByUrl(this.menuItemList[index]['items'][0]['routerLink']);
    }
  }

  private openNewTab(route: string) {
    const url = this.router.serializeUrl(this.router.createUrlTree([route]));
    window.open(url, '_blank');
  }
}
